import Icon from '../components/Icon.vue'

Icon.register({
  om: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M360.6 60.9A10.4-10.4 0 0 1 375.4 60.9L396.9 39.4A10.4-10.4 0 0 1 396.9 24.6L375.4 3.1C371.3-1 364.7-1 360.6 3.1L339 24.6A10.4-10.4 0 0 1 339 39.4L360.6 60.9zM412.1 192C385.4 192 360.3 202.4 341.5 221.3L317.2 245.5C310.4 252.3 301.4 256 291.8 256H245C255.5 233.9 259.2 207.9 252.7 180.8 242.6 138.2 206.4 104.7 163.2 97.6 127.1 91.6 92.3 102.6 67.2 126.4 59.8 133.3 60.2 145.2 68.3 151.3L94.5 170.9C100.2 175.2 108.1 175.2 113.7 170.7 122.1 163.8 132.7 160 143.9 160 170.4 160 191.9 181.5 191.9 208S170.4 256 143.9 256H112C100.1 256 92.3 268.6 97.7 279.3L113.7 311.4C116.3 316.5 121.3 319.6 126.9 320H159.9C195.2 320 223.9 348.7 223.9 384S195.2 448 159.9 448C63.9 448 37.6 394 14.8 356 10.3 348.4 0 352.4 0 361.2-0.1 416 41.1 512 159.9 512 230.5 512 288 454.6 288 384 288 360.6 281.2 338.9 270.2 320H291.8C318.5 320 343.6 309.6 362.5 290.8L386.7 266.5C393.5 259.7 402.5 256 412.1 256 431.9 256 448 272.1 448 291.9V392C448 405.2 429.2 416 416 416 376.6 416 349.3 391.8 334.2 373.1 329.4 367.2 320 370.6 320 378.1V416S320 480 416 480C464.5 480 512 440.5 512 392V291.9C512 236.8 467.2 192 412.1 192zM454.3 67.3C368.7 132.4 285.2 70 281.7 67.3 275.7 62.7 267.3 62.9 261.6 67.9 255.8 72.8 254.3 81 257.9 87.7 259.5 90.6 298.3 160 376.7 160 456.6 160 475.5 128.6 478.5 122.4 479.5 120.2 480 117.9 480 115.5V80C480 66.8 464.9 59.3 454.3 67.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/om.js
// module id = guKf
// module chunks = 144